import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

const slideUp = keyframes`
  0% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(0%);
  }
`;

export const StackWrapper = styled(Flex)`
  position: fixed;
  z-index: ${VIEWER_Z_INDEX.ctaFormLayer};
  top: 60px;
  width: 100%;
  height: calc(100% - 40px);

  animation: ${slideUp} 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
`;

export const FlexFixedBottomCTAButtonWrapper = styled(Flex)`
  position: fixed;
  bottom: 0;
  left: 0;
  background: linear-gradient(0deg, #fff 30.73%, rgb(255 255 255 / 0%) 100%);
`;

export const FlexBottomWrapper = styled.div<{
  isMobileLandscape?: boolean;
  isDisableHelpers?: boolean;
  isDrawerOpen?: boolean;
}>`
  position: fixed;
  bottom: ${({ isDrawerOpen, isDisableHelpers, isMobileLandscape }) =>
    isDrawerOpen && isDisableHelpers
      ? '160px'
      : isDrawerOpen && !isDisableHelpers
      ? '220px'
      : isDisableHelpers
      ? '30px'
      : isMobileLandscape
      ? '100px'
      : '70px'};
  display: flex;
  width: 100%;
  align-items: center;

  /* 전폭 스트립이 슬라이드 터치를 가로채지 않도록 버튼에만 이벤트를 허용한다 */
  pointer-events: none;
`;
